export default function catchError(error, failedCallback) {
  if (error.response) { failedCallback(error.response) }
  else if (error.request) { console.log(error.request) }
  else { console.log('catchError:', error) }
}
